export const charactersOnlyRegex = /[a-zA-Z]/;
export const digitsOnlyRegex = /^[0-9]+$/;
export const charactersAndDigitsOnlyRegex = /[A-Za-z0-9]/;
